// extracted by mini-css-extract-plugin
module.exports = {"loading":"pouchband-registry-search_loading__2h_aA","container":"pouchband-registry-search_container__3c-ay"};